var _style, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 400",
    style: {
      enableBackground: "new 0 0 432 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#F5F5F5;}\n\t.st2{fill:#F0F0F0;}\n\t.st3{fill:#E6E6E6;}\n\t.st4{fill:#002C90;}\n\t.st5{opacity:0.3;}\n\t.st6{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:0.2;fill:#002C90;enable-background:new    ;}\n\t.st8{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st9{opacity:0.4;fill:#002C90;enable-background:new    ;}\n\t.st10{opacity:0.2;enable-background:new    ;}\n\t.st11{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st12{opacity:0.3;fill:#002C90;enable-background:new    ;}\n\t.st13{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st14{fill:#263238;}\n\t.st15{fill:#FFFFFF;}\n\t.st16{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st17{opacity:0.6;fill:#002C90;enable-background:new    ;}\n\t.st18{opacity:0.5;fill:#002C90;enable-background:new    ;}\n\t.st19{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "79.1,118.2 80.7,121.5 84.3,122 81.7,124.6 82.3,128.2 79.1,126.5 75.8,128.2 76.4,124.6 73.8,122  77.4,121.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "402.7,272.5 404.3,275.7 407.9,276.3 405.3,278.8 405.9,282.4 402.7,280.7 399.5,282.4 400.1,278.8  397.5,276.3 401.1,275.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "338.6,367.5 340.2,370.8 343.8,371.3 341.2,373.9 341.8,377.5 338.6,375.8 335.4,377.5 336,373.9  333.4,371.3 337,370.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.9,60.1l0.6,1.2l1.4,0.2c0.2,0,0.4,0.2,0.3,0.4c0,0.1-0.1,0.2-0.1,0.2l-1,0.9l0.2,1.3 c0,0.2-0.1,0.4-0.3,0.5c-0.1,0-0.2,0-0.2,0l-1.2-0.6l-1.2,0.6c-0.2,0.1-0.4,0-0.6-0.2c0-0.1-0.1-0.2,0-0.2l0.2-1.3l-1-0.9 c-0.2-0.2-0.2-0.4,0-0.6c0.1-0.1,0.2-0.1,0.2-0.1l1.3-0.2l0.6-1.2c0.1-0.2,0.3-0.3,0.5-0.3C191.8,59.9,191.9,60,191.9,60.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,352l0.6,1.2l1.3,0.2c0.2,0,0.4,0.2,0.4,0.5c0,0.1-0.1,0.2-0.1,0.2l-1,0.9l0.2,1.3c0,0.2-0.1,0.4-0.3,0.5 c-0.1,0-0.2,0-0.2,0l-1.2-0.6l-1.2,0.6c-0.2,0.1-0.4,0-0.6-0.2c0-0.1-0.1-0.2,0-0.2l0.2-1.3l-1-0.9c-0.2-0.2-0.2-0.4,0-0.6 c0.1-0.1,0.1-0.1,0.2-0.1l1.3-0.2L26,352c0.1-0.2,0.3-0.3,0.5-0.3C26.6,351.8,26.7,351.9,26.8,352z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,47.3l0.6,1.2l1.3,0.2c0.2,0,0.4,0.2,0.3,0.5c0,0.1-0.1,0.2-0.1,0.2l-1,1l0.2,1.3c0,0.2-0.1,0.4-0.3,0.5 c-0.1,0-0.2,0-0.3,0l-1.2-0.6l-1.2,0.6c-0.2,0.1-0.4,0-0.5-0.1c0-0.1-0.1-0.2,0-0.3l0.2-1.3l-1-1c-0.2-0.2-0.2-0.4,0-0.6 c0.1-0.1,0.1-0.1,0.2-0.1l1.3-0.2l0.6-1.2c0.1-0.2,0.3-0.3,0.5-0.2C53.6,47.1,53.7,47.2,53.8,47.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.1,288.3c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3l0,0C51.5,287,52.1,287.6,52.1,288.3 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.7,121.9c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3l0,0 C241.1,120.5,241.7,121.1,241.7,121.9L241.7,121.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.7,48.4c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3C172.1,47.1,172.7,47.6,172.7,48.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 173.1,
    cy: 365.4,
    r: 7.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.6,361.1c-1.5,0-3,0.5-4.2,1.4c-1.6,3.7,0.1,8,3.8,9.7c2.2,0.9,4.7,0.8,6.7-0.4l0,0 c1.9-3.5,0.6-7.8-2.9-9.7C173,361.4,171.8,361.1,170.6,361.1L170.6,361.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.7,237.6H52.8v-27.5l60.8-72.3h29.1v73.9h15.1v25.9h-15.1v22.5h-29.1L113.7,237.6L113.7,237.6z  M113.7,211.7v-37.8l-32.2,37.8H113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.3,199.5c0-22.9,4.1-38.9,12.3-48s20.8-13.7,37.6-13.7c8.1,0,14.7,1,19.9,3c4.7,1.7,9,4.4,12.7,7.8 c3.1,2.9,5.7,6.3,7.8,10.1c2,3.9,3.6,8.1,4.5,12.3c2.3,9.2,3.4,18.6,3.4,28c0,21.8-3.7,37.8-11.1,47.9s-20.1,15.2-38.1,15.2 c-10.1,0-18.3-1.6-24.5-4.8c-6.3-3.3-11.6-8.2-15.3-14.2c-2.9-4.4-5.2-10.5-6.8-18.2C169,216.5,168.2,208,168.3,199.5z  M201.4,199.6c0,15.3,1.3,25.8,4.1,31.4c2.7,5.6,6.6,8.4,11.8,8.4c3.3,0,6.5-1.2,8.8-3.6c2.5-2.4,4.3-6.1,5.5-11.3 c1.2-5.1,1.8-13.1,1.8-24c0-16-1.4-26.7-4.1-32.2c-2.7-5.5-6.8-8.2-12.2-8.2c-5.5,0-9.5,2.8-12,8.4 C202.6,174.1,201.4,184.4,201.4,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M337.7,237.6h-60.8v-27.5l60.9-72.3h29.1v73.9H382v25.9h-15.1v22.5h-29.1L337.7,237.6L337.7,237.6z  M337.7,211.7v-37.8l-32.1,37.8H337.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167,95.6c0,1-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9l0,0C166.2,93.7,167,94.6,167,95.6 L167,95.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 39,
    cy: 166.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 257,
    cy: 358.3,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 302.5,
    cy: 282,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M390.2,45.6c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3S390.2,44.9,390.2,45.6L390.2,45.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.8,19c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3S138.7,18.2,138.8,19z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 243.7,
    cy: 86.9,
    r: 1.3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 107.2,
    cy: 66.3,
    r: 21.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 107.2,
    cy: 66.3,
    r: 21.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M99.7,49.8c-3,0-5.9,0.6-8.7,1.8c-8.1,9-7.5,22.8,1.5,31c6.4,5.8,15.5,7.3,23.4,3.9l0,0c8.1-9,7.5-22.8-1.5-31 C110.3,51.8,105.1,49.8,99.7,49.8L99.7,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.5,55.6c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S97.5,54.5,97.5,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M121.1,53.6c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S121.1,52.5,121.1,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.1,67.9c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3l0,0C115.6,64.6,117.1,66.1,117.1,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.6,77.2c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4s2-4.4,4.4-4.4S106.6,74.8,106.6,77.2L106.6,77.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 348.2,
    cy: 326.2,
    r: 19.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 348.2,
    cy: 326.2,
    r: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M360.3,311.3c-10.2-3.1-20.9,2.7-24,12.8c-2.3,7.5,0.2,15.6,6.3,20.5c1.8,0.5,3.7,0.8,5.5,0.8 c10.6,0,19.2-8.6,19.2-19.2C367.4,320.4,364.8,315,360.3,311.3L360.3,311.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.8,332c-20.5,9.7-5.2,17.1,23.7,6.7c26.8-9.6,37-21.8,13-18C367.8,325.7,334.3,338.8,329.8,332z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Astronaut--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M360.1,137.8c-26.9,18.2-61.7,42.2-71.3,99.8h-2c9.4-57,42.9-81.6,69.8-99.8H360.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221,318.2c-17,0-33.8-7.7-42-20.2c-5.1-7.7-10.9-24,6.6-45.6l1.6,1.3c-12.4,15.3-14.6,30.6-6.4,43.2 c10,15.3,33.6,23,53.7,17.5c20.6-5.6,33.1-23.5,34.4-49.2c4.1-87.8,50.8-114.9,84.8-134.6c21.2-12.3,36.5-21.1,33.1-39.8 c-0.5-2.6-1.5-4.4-3.2-5.5c-4.4-2.9-12.9-0.9-22.7,1.4c-19.3,4.5-45.8,10.7-61.5-16.1l1.7-1c15,25.5,39.6,19.8,59.3,15.2 c10.3-2.4,19.2-4.5,24.2-1.1c2.1,1.4,3.5,3.6,4,6.8c3.6,20.1-13,29.7-34,41.9c-33.7,19.5-79.8,46.2-83.9,133 c-1.3,26.6-14.3,45.2-35.8,51.1C230.4,317.7,225.7,318.3,221,318.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M221,318.2c-17,0-33.8-7.7-42-20.2c-5.1-7.7-10.9-24,6.6-45.6l1.6,1.3c-12.4,15.3-14.6,30.6-6.4,43.2 c10,15.3,33.6,23,53.7,17.5c20.6-5.6,33.1-23.5,34.4-49.2c4.1-87.8,50.8-114.9,84.8-134.6c21.2-12.3,36.5-21.1,33.1-39.8 c-0.5-2.6-1.5-4.4-3.2-5.5c-4.4-2.9-12.9-0.9-22.7,1.4c-19.3,4.5-45.8,10.7-61.5-16.1l1.7-1c15,25.5,39.6,19.8,59.3,15.2 c10.3-2.4,19.2-4.5,24.2-1.1c2.1,1.4,3.5,3.6,4,6.8c3.6,20.1-13,29.7-34,41.9c-33.7,19.5-79.8,46.2-83.9,133 c-1.3,26.6-14.3,45.2-35.8,51.1C230.4,317.7,225.7,318.3,221,318.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278.8,47c4.6,0,9.2,0.7,13.6,2.1c0,0,11,18.8,12.3,23.1c-0.5,4.2-7.6,11.2-7.6,11.2L278.8,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M278.8,47c4.6,0,9.2,0.7,13.6,2.1c0,0,11,18.8,12.3,23.1c-0.5,4.2-7.6,11.2-7.6,11.2L278.8,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.3,138.1c-4.2-5.2-8.1-10.7-11.6-16.4c-0.8-1.4-1.6-2.9-2.4-4.4c-0.4-0.9-0.8-1.7-1.2-2.6 c-0.5-0.8-0.9-1.7-1.2-2.7c-1.2-12.7,3.1-22-1-32.2l-16.5,6.4c0,0,1.4,18.1,4.6,29c2,6.7,6.5,12.6,10.8,17.9c1.4,1.7,2.6,3.4,4,5.1 s2.7,3.1,4,4.6c2,2.4,2.6,4.7,1.1,7.6l-0.2,0.4c-0.4,0.7,1.5,1.6,2.8,0c2-2.6,1.7-2.4,3.5-4.6c1.1-1.3,2.3-2.8,3.3-4 C312.3,141.2,312.4,139.4,311.3,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M311.3,138.1c-4.2-5.2-8.1-10.7-11.6-16.4c-0.8-1.4-1.6-2.9-2.4-4.4c-0.4-0.9-0.8-1.7-1.2-2.6 c-0.5-0.8-0.9-1.7-1.2-2.7c-1.2-12.7,3.1-22-1-32.2l-16.5,6.4c0,0,1.4,18.1,4.6,29c2,6.7,6.5,12.6,10.8,17.9c1.4,1.7,2.6,3.4,4,5.1 s2.7,3.1,4,4.6c2,2.4,2.6,4.7,1.1,7.6l-0.2,0.4c-0.4,0.7,1.5,1.6,2.8,0c2-2.6,1.7-2.4,3.5-4.6c1.1-1.3,2.3-2.8,3.3-4 C312.3,141.2,312.4,139.4,311.3,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M307.3,132.9c-2.6,2.8-5.5,5.3-8.7,7.5c0.4,0.5,0.9,1,1.3,1.5c3.1-2.1,6-4.6,8.5-7.5L307.3,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M311.3,138.1l-0.1-0.1c-0.8,0.9-1.2,2-1.3,3.2c-0.1,0.8,0.1,1.6,0.4,2.4l1-1.1 C312.3,141.1,312.3,139.4,311.3,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.8,59c-1.8,2.7-3.9,5.1-6.4,7.2c-1.4,1.2-2.8,2.2-4.4,3c-0.8,0.4-1.7,0.8-2.6,1.1l-0.7,0.2l-0.2,0.1 l-0.5,0.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.8,0.1-1.7,0-2.5-0.2c-1-0.3-2-0.7-2.9-1.3c-0.7-0.4-1.5-0.9-2.1-1.4c-1.3-0.9-2.4-1.9-3.6-3 c-2.2-2.1-4.2-4.3-6-6.7c-0.8-1.1-0.6-2.7,0.5-3.5c0.8-0.6,2-0.7,2.8-0.1h0.1c2.4,1.5,4.7,3.1,7.1,4.5c1.2,0.7,2.3,1.4,3.5,1.9 c0.5,0.3,1,0.5,1.6,0.7c0.3,0.1,0.7,0.2,1.1,0.3c0.1,0,0-0.1-0.4-0.1c-0.1,0-0.2,0-0.4,0l-0.2,0.1l0,0l0.3-0.2 c0.4-0.2,0.9-0.5,1.3-0.8c0.9-0.6,1.7-1.3,2.5-2.1c1.7-1.8,3.4-3.8,4.9-5.8l0,0c1.8-2.1,5-2.2,7.1-0.4c1.8,1.6,2.2,4.3,0.9,6.3 L274.8,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.8,59c-1.8,2.7-3.9,5.1-6.4,7.2c-1.4,1.2-2.8,2.2-4.4,3c-0.8,0.4-1.7,0.8-2.6,1.1l-0.7,0.2l-0.2,0.1 l-0.5,0.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.8,0.1-1.7,0-2.5-0.2c-1-0.3-2-0.7-2.9-1.3c-0.7-0.4-1.5-0.9-2.1-1.4c-1.3-0.9-2.4-1.9-3.6-3 c-2.2-2.1-4.2-4.3-6-6.7c-0.8-1.1-0.6-2.7,0.5-3.5c0.8-0.6,2-0.7,2.8-0.1h0.1c2.4,1.5,4.7,3.1,7.1,4.5c1.2,0.7,2.3,1.4,3.5,1.9 c0.5,0.3,1,0.5,1.6,0.7c0.3,0.1,0.7,0.2,1.1,0.3c0.1,0,0-0.1-0.4-0.1c-0.1,0-0.2,0-0.4,0l-0.2,0.1l0,0l0.3-0.2 c0.4-0.2,0.9-0.5,1.3-0.8c0.9-0.6,1.7-1.3,2.5-2.1c1.7-1.8,3.4-3.8,4.9-5.8l0,0c1.8-2.1,5-2.2,7.1-0.4c1.8,1.6,2.2,4.3,0.9,6.3 L274.8,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.3,52.4l1.2,2c0,0,0.9,2.6,2.7,3.1l4.9-1.6l-0.2-0.4l0,0c-0.6-0.9-0.5-2.8-0.3-4.3s-0.6-1.6-1.1-1.2 c-0.4,0.5-0.7,1-0.8,1.7c-0.2-0.3-0.5-0.6-0.8-0.9l-1.5-1.5c-0.6-0.6-1.7-0.7-2.3-0.1l-1.2,1.1C238,50.8,237.9,51.7,238.3,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M238.3,52.4l1.2,2c0,0,0.9,2.6,2.7,3.1l4.9-1.6l-0.2-0.4l0,0c-0.6-0.9-0.5-2.8-0.3-4.3s-0.6-1.6-1.1-1.2 c-0.4,0.5-0.7,1-0.8,1.7c-0.2-0.3-0.5-0.6-0.8-0.9l-1.5-1.5c-0.6-0.6-1.7-0.7-2.3-0.1l-1.2,1.1C238,50.8,237.9,51.7,238.3,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.7,45.2c-5.4,1.4-10.6,3.6-15.3,6.5c-1.5,1-2.3,2.8-1.9,4.5c1.9,9.4,6.3,22.1,11.1,30.1l22.1-9.2 c0.1-3.9-5.2-16.5-10.7-28.7C287.9,46.3,286,44.6,283.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M283.7,45.2c-5.4,1.4-10.6,3.6-15.3,6.5c-1.5,1-2.3,2.8-1.9,4.5c1.9,9.4,6.3,22.1,11.1,30.1l22.1-9.2 c0.1-3.9-5.2-16.5-10.7-28.7C287.9,46.3,286,44.6,283.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M292.3,56.2l-4.4-1.5c1,2.6,4.5,5.8,7,7.7C294.1,60.4,293.2,58.3,292.3,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.2,35.3c-1.8-3.5-5.8-5.2-10.5-4.8c-4,0.3-7.5,4.4-7.1,6.6s3.8,3.1,4.4,3.9l-2.8,2c-1.3,1-1.6,2.8-0.7,4.2 l0.1,0.1c1.2,1.5,2.7,3,3.6,4.1c7.7-0.2,13.3-3.1,15.4-5.9C283.8,41.9,284,38.8,282.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M282.2,35.3c-1.8-3.5-5.8-5.2-10.5-4.8c-4,0.3-7.5,4.4-7.1,6.6s3.8,3.1,4.4,3.9l-2.8,2 c-1.3,1-1.6,2.8-0.7,4.2l0.1,0.1c1.2,1.5,2.7,3,3.6,4.1c7.7-0.2,13.3-3.1,15.4-5.9C283.8,41.9,284,38.8,282.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M278.5,37.5c1.5,3.9-0.4,8.3-4.3,9.8s-8.3-0.4-9.8-4.3s0.4-8.3,4.3-9.8C272.5,31.6,276.9,33.6,278.5,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343.4,127.6c-0.1-3.3-0.3-3-0.4-5.8c-0.1-1.7-0.1-3.6-0.1-5.2s-1.1-3-2.7-3.3c-1.3-0.3-2.6-0.5-4-0.8 c-1.7-0.4-3.4-0.8-5.1-1.3c-1.3-0.4-2.6-0.8-3.9-1.3s-2.7-1-4.1-1.6c-1.6-0.7-3.1-1.4-4.7-2.1c-1.7-0.8-3.4-1.7-5.1-2.6 c-6.6-10.9-6.7-18.1-13.8-26.5L284.4,84c0,0,11.1,19.8,18.7,28.1c4.4,4.8,11.2,7,17.3,8.6c4.4,1.1,8.9,2,13.4,2.8 c1.7,0.3,3.6,0.4,5.1,1.5c1.1,0.9,1.9,2.1,2.1,3.4c0.1,0.3,0.1,0.6,0.2,0.8C341.4,130.2,343.5,129.6,343.4,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M343.4,127.6c-0.1-3.3-0.3-3-0.4-5.8c-0.1-1.7-0.1-3.6-0.1-5.2s-1.1-3-2.7-3.3c-1.3-0.3-2.6-0.5-4-0.8 c-1.7-0.4-3.4-0.8-5.1-1.3c-1.3-0.4-2.6-0.8-3.9-1.3s-2.7-1-4.1-1.6c-1.6-0.7-3.1-1.4-4.7-2.1c-1.7-0.8-3.4-1.7-5.1-2.6 c-6.6-10.9-6.7-18.1-13.8-26.5L284.4,84c0,0,11.1,19.8,18.7,28.1c4.4,4.8,11.2,7,17.3,8.6c4.4,1.1,8.9,2,13.4,2.8 c1.7,0.3,3.6,0.4,5.1,1.5c1.1,0.9,1.9,2.1,2.1,3.4c0.1,0.3,0.1,0.6,0.2,0.8C341.4,130.2,343.5,129.6,343.4,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M335.7,112.4c-0.6-0.1-1.2-0.3-1.8-0.4c0,3.5-1.6,9.4-2.2,11.2l1.9,0.4C334.9,120,335.6,116.2,335.7,112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M343,116.6c0-1.6-1.1-3-2.7-3.3l-1-0.2c0.2,1.1,0.7,2.2,1.6,2.9c0.6,0.5,1.3,0.9,2,1.1 C343,117,343,116.8,343,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M277,37.5c0.4,1.5-1.3,3.1-2.6,1.8c-1.3-1.4-2.6-2.6-4.1-3.7c-1.4-0.9,0.5-2.4,2.6-1.8 C274.8,34.3,276.4,35.7,277,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.2,85.8c-0.7,0.3,0.6,1.5,0.6,1.5s14-4.8,22.5-9.7c0-0.6-0.2-1.2-0.7-1.6C292.3,79.7,284.8,83,277.2,85.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M277.2,85.8c-0.7,0.3,0.6,1.5,0.6,1.5s14-4.8,22.5-9.7c0-0.6-0.2-1.2-0.7-1.6C292.3,79.7,284.8,83,277.2,85.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.5,44.5c2.8,1.4,5.4,2.9,8,4.5c1.3,0.8,2.6,1.7,3.8,2.6s2.5,1.8,3.8,2.9l0.5,0.4l0.6,0.5 c0.4,0.3,0.7,0.6,1,1c0.3,0.3,0.6,0.7,0.9,1s0.5,0.7,0.8,1c0.9,1.3,1.8,2.6,2.6,4c1.5,2.7,2.9,5.5,4,8.3c0.5,1.3-0.2,2.8-1.5,3.2 c-1,0.4-2,0.1-2.7-0.6v-0.1c-2-2.1-3.9-4.4-5.9-6.5s-3.9-4.2-5.5-5.1c-2.3-1.4-4.8-2.8-7.3-4.2l-7.6-4.2l0,0 c-2.4-1.3-3.4-4.3-2.1-6.8C282.1,44.1,285.1,43.2,287.5,44.5L287.5,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M287.5,44.5c2.8,1.4,5.4,2.9,8,4.5c1.3,0.8,2.6,1.7,3.8,2.6s2.5,1.8,3.8,2.9l0.5,0.4l0.6,0.5 c0.4,0.3,0.7,0.6,1,1c0.3,0.3,0.6,0.7,0.9,1s0.5,0.7,0.8,1c0.9,1.3,1.8,2.6,2.6,4c1.5,2.7,2.9,5.5,4,8.3c0.5,1.3-0.2,2.8-1.5,3.2 c-1,0.4-2,0.1-2.7-0.6v-0.1c-2-2.1-3.9-4.4-5.9-6.5s-3.9-4.2-5.5-5.1c-2.3-1.4-4.8-2.8-7.3-4.2l-7.6-4.2l0,0 c-2.4-1.3-3.4-4.3-2.1-6.8C282.1,44.1,285.1,43.2,287.5,44.5L287.5,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.7,75.7l-0.9-2.1c0,0-0.5-2.7-2.2-3.5l-5,0.8l0.2,0.4l0,0c0.5,1,0.1,2.8-0.3,4.3s0.3,1.7,1,1.4 c0.4-0.2,0.7-0.8,1.1-1.5c0.2,0.3,0.4,0.7,0.6,1l1.2,1.7c0.5,0.7,1.5,0.9,2.3,0.4l1.4-0.9C315.8,77.3,316,76.5,315.7,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M315.7,75.7l-0.9-2.1c0,0-0.5-2.7-2.2-3.5l-5,0.8l0.2,0.4l0,0c0.5,1,0.1,2.8-0.3,4.3s0.3,1.7,1,1.4 c0.4-0.2,0.7-0.8,1.1-1.5c0.2,0.3,0.4,0.7,0.6,1l1.2,1.7c0.5,0.7,1.5,0.9,2.3,0.4l1.4-0.9C315.8,77.3,316,76.5,315.7,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M283.2,56l-1.2,0.1l-7.5,18.1c0.4,0,0.8,0,1.2-0.1c0,0,9.8-3.6,12.7-5C286.5,65,283.2,56,283.2,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M269.6,60.8c0.9,4.7,2.6,9.3,5,13.4c3.7-1.3,9.8-3.6,12.7-5c-2-4.3-3.8-8.6-5.3-13.1 C278.9,56.3,272,59,269.6,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M277,64.7c-0.4,1.4-1.8,2.1-3.2,1.7c-1.4-0.4-2.1-1.8-1.7-3.2s1.8-2.1,3.2-1.7l0,0 C276.6,61.9,277.4,63.3,277,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M278.9,61.2c-0.1,0.5-0.6,0.7-1,0.6c-0.5-0.1-0.7-0.6-0.6-1c0.1-0.5,0.6-0.7,1-0.6c0,0,0,0,0.1,0 C278.8,60.4,279,60.8,278.9,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M281.1,60.4c-0.1,0.5-0.5,0.8-1,0.7s-0.8-0.5-0.7-1c0-0.1,0-0.1,0-0.2c0.1-0.4,0.6-0.7,1-0.6l0,0 C281,59.5,281.3,59.9,281.1,60.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "284.3,68.2 275,71.8 274.5,70 283.7,66.3  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M233.3,207.1c0,5.8-0.6,11.6-1.7,17.4c-1.2,5.1-3,8.9-5.5,11.3c-2.3,2.3-5.5,3.6-8.8,3.6 c-5.1,0-9.1-2.8-11.8-8.4c-0.5-1-0.9-2-1.2-3.1c-5.7,4.9-11,10.3-15.9,16l-5.3,6.3c2.9,2.9,6.2,5.3,9.8,7.2 c6.2,3.2,14.4,4.8,24.5,4.8c1.8,0,3.5,0,5.2-0.1c6.1-9.1,11.2-18.8,15.1-29l14.9-38.7L233.3,207.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.4,260l17.5,17.5l49-46.2C149,224.9,116.2,243.2,99.4,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M160.4,321c-5.6-5.6-17.5-17.5-17.5-17.5l46.2-49C195.5,271.3,177.2,304.2,160.4,321z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.4,210.7l19.1-36.8L209.7,193c-11.8,6.1-22.7,13.9-32.4,23l-62.8,59l30.8,30.8l59.1-62.8 C213.5,233.4,221.3,222.5,227.4,210.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M227.4,210.7l19.1-36.8L209.7,193c-11.8,6.1-22.7,13.9-32.4,23l-62.8,59l30.8,30.8l59.1-62.8 C213.5,233.4,221.3,222.5,227.4,210.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 188.2,
    cy: 232.2,
    r: 12.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 188.2,
    cy: 232.2,
    r: 8.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "155.8,294.8 125.6,264.6 150.3,241.3 179,270.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.2,287.6c-22.6,1.8-30.1,16.3-32.7,35.5c-1.3,9.8-1.9,19.7-10.1,25.5c-1.3,0.9-1.6,2.6-0.7,3.8 c0.5,0.8,1.4,1.2,2.4,1.2c30.3-1,44.5-15.8,46.3-22c-0.5,3.2-1.3,6.4-2.5,9.5c-0.6,1.4,0.1,3,1.5,3.6c0.8,0.3,1.7,0.3,2.5-0.2 c8.5-5.3,19.2-15.1,19.9-31.1C126.5,304.6,106.2,287.6,106.2,287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.2,287.6c-22.6,1.8-30.1,16.3-32.7,35.5c-1.3,9.8-1.9,19.7-10.1,25.5c-1.3,0.9-1.6,2.6-0.7,3.8 c0.5,0.8,1.4,1.2,2.4,1.2c30.3-1,44.5-15.8,46.3-22c-0.5,3.2-1.3,6.4-2.5,9.5c-0.6,1.4,0.1,3,1.5,3.6c0.8,0.3,1.7,0.3,2.5-0.2 c8.5-5.3,19.2-15.1,19.9-31.1C126.5,304.6,106.2,287.6,106.2,287.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "136.3,320.3 100.1,284.1 119.4,279.9 140.4,301  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImg);
export default __webpack_public_path__ + "static/media/error-img.177a43336d4ced0b81082eae7f2bce3b.svg";
export { ForwardRef as ReactComponent };